import { motion } from "framer-motion";
import { HERO_IMAGE } from "@/data/site";

const line = (d) => ({
  hidden: { y: "110%", opacity: 0 },
  show: { y: "0%", opacity: 1, transition: { duration: 1.05, delay: d, ease: [0.2, 0.8, 0.2, 1] } },
});

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-32 md:pt-40 pb-14 md:pb-20 bg-[#f7f5f0]">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <motion.div initial="hidden" animate="show" className="max-w-5xl">
          <motion.div variants={line(0.1)} className="label-eyebrow mb-6 flex items-center gap-3">
            <span className="w-6 h-px bg-[#FF6B1A]" />
            <span>Un ecosistema di comunicazione</span>
          </motion.div>
          <h1 className="font-display tighter text-[#121212] text-[11vw] sm:text-[8vw] md:text-[6vw] lg:text-[5.2vw] leading-[0.98] font-normal">
            <span className="block overflow-hidden">
              <motion.span className="block" variants={line(0.25)}>Contenuti che raccontano.</motion.span>
            </span>
            <span className="block overflow-hidden">
              <motion.span className="block italic text-[#FF6B1A]" variants={line(0.45)}>Canali che amplificano.</motion.span>
            </span>
          </h1>
          <motion.p variants={line(0.85)} className="mt-10 max-w-2xl text-[#121212]/70 text-lg md:text-xl leading-relaxed">
            Modo Motori è il media digitale video-first che unisce informazione, passione e opportunità di comunicazione per concessionarie, dealer e brand automotive.
          </motion.p>
        </motion.div>
      </div>

      {/* Hero image / video placeholder */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
        className="mt-14 md:mt-20"
      >
        <div className="max-w-[1280px] mx-auto px-5 md:px-8">
          <div className="relative aspect-[16/8] md:aspect-[16/7] rounded-xl overflow-hidden ring-1 ring-black/[0.08]">
            <img src={HERO_IMAGE} alt="Automotive editorial" className="w-full h-full object-cover" loading="eager" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
          </div>
        </div>
      </motion.div>
    </section>
  );
}
